<template>
  <div>
    <el-dialog
      title="选择装置"
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="1000px"
      class="ecology-settlement-dialog"
    >
      <div class="content">
        <Search ref="search" :searchConfig="searchConfig" @doSearch="doSearch">
        </Search>
        <Table ref="table" class="table" :tableConfig="tableConfig"> </Table>
      </div>
      <div :slot="'footer'">
        <el-button @click="onClose" size="small">关 闭</el-button>
        <el-button @click="onConfirm" type="primary" size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Table from "./table.vue";
import Search from "./search.vue";
export default {
  components: {
    Table,
    Search,
  },
  data() {
    return {
      visible: false,
      searchConfig: {
        params: [
          {
            prop: "projectName",
            label: "项目名称",
          },
        ],
      },
      tableConfig: {
        searchUrl:
          "/front/oms/omsSsoSupplierSettle/distinctSupplierOrderByDevice", // 搜索接口
        searchMethod: "POST", // 接口请求方式
        needPagination: true, // 是否需要分页
        fluidHeight: true, // 流体高度
        showOrdinal: true, // 是否显示序号,
        count: "total",
        resultListName: "records",
        showCheckBox: true, // 是否显示多选框
        checkBoxRowKey: "ssoSupplierOrderNo",
        params: [
          {
            prop: "ssoSupplierOrderNo",
            label: "报工单号",
            width: 120,
          },
          {
            prop: "projectName",
            label: "项目名称",
            minWidth: 140,
          },
          {
            prop: "projectManager",
            label: "项目经理",
            width: 100,
          },
          {
            prop: "deviceName",
            label: "装置名称",
            minWidth: 140,
          },
          {
            prop: "workDescription",
            label: "工作内容",
            minWidth: 160,
            showOverflowTooltip: true,
          },
          {
            prop: "workStatusStr",
            label: "工作状态",
            width: 100,
          },
          {
            prop: "deliveryNum",
            label: "工时(小时)",
            width: 100,
          },
          {
            prop: "supplierOrderCreateTime",
            label: "填报日期",
            width: 120,
          },
        ],
        extra: {},
      },
      supplierOrderIdList: [],
    };
  },
  methods: {
    onShow(supplierOrderIdList) {
      console.log("onShow supplierOrderIdList", supplierOrderIdList);

      this.visible = true;
      this.supplierOrderIdList = supplierOrderIdList;
      this.$nextTick(() => {
        this.$refs.table.multipleSelection.forEach((i) => {
          this.$refs.table.$refs.tableList.toggleRowSelection(i, false);
        });
        this.$refs.table.handleSelectionChange([]);

        this.$refs.search.doSearch();
      });
    },
    doSearch(params) {
      console.log("doSearch supplierOrderIdList", this.supplierOrderIdList);

      this.tableConfig.extra = {
        ...params,
        supplierOrderIdList: this.supplierOrderIdList,
      };
      this.$refs.table.getList();
    },
    onConfirm() {
      const arr = this.$refs.table.multipleSelection;
      if (!arr || !arr.length) {
        this.$message.warning("请选择报工单");
        return;
      }
      this.$emit("confirm", arr);
      this.onClose();
    },
    onClose() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  height: 600px;
}
</style>

<style lang="scss">
.ecology-settlement-dialog {
  .el-dialog__title {
    font-family: Alibaba PuHuiTi;
    font-size: 20px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .el-icon-close {
    color: #333;
    font-weight: 600;
  }

  .el-dialog__body {
    padding: 10px 20px;
  }
}
</style>
